<template>
  <div class="login-container">
    <div class="login-card">
      <!-- Sección izquierda - Bienvenida -->
      <div class="welcome-section">
        <div class="welcome-background">
          <div class="shape shape-1"></div>
          <div class="shape shape-2"></div>
          <div class="shape shape-3"></div>
          <div class="shape shape-4"></div>
        </div>
        <div class="welcome-content">
          <h1 class="welcome-title">Bienvenido de nuevo!</h1>
        </div>
      </div>

      <!-- Sección derecha - Formulario -->
      <div class="form-section">
        <div class="form-content">
          <!-- Header del formulario -->
          <div class="form-header">
            <div class="form-icon">
              <v-icon size="48" color="#3b82f6">mdi-account-circle</v-icon>
            </div>
            <h2 class="form-title">Iniciar Sesión</h2>
            <p class="form-subtitle">
              Accede a tu cuenta del Sistema de Compras
            </p>
            <div class="form-divider"></div>
          </div>

          <v-form @submit.prevent="IniciarSesion()" class="login-form">
            <!-- Campo Cédula -->
            <div class="field-container">
              <v-text-field
                v-model="cedula"
                label="Cédula"
                type="text"
                variant="outlined"
                class="custom-field"
                autofocus
                autocomplete="off"
                :rules="[rules.required]"
                hide-details="auto"
                prepend-inner-icon="mdi-account-outline"
              ></v-text-field>
            </div>

            <!-- Campo Contraseña -->
            <div class="field-container password-field-container">
              <v-text-field
                v-model="contrasena"
                label="Contraseña"
                :type="showPassword ? 'text' : 'password'"
                variant="outlined"
                class="custom-field"
                @keyup.enter="IniciarSesion()"
                :rules="[rules.required]"
                hide-details="auto"
                prepend-inner-icon="mdi-lock-outline"
              ></v-text-field>
              <svg
                v-if="!showPassword"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#6b7280"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                :class="[
                  'password-toggle-icon',
                  { 'is-disabled': !contrasena },
                ]"
                @click="showPassword = !showPassword"
              >
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <svg
                v-else
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#6b7280"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                :class="[
                  'password-toggle-icon',
                  { 'is-disabled': !contrasena },
                ]"
                @click="showPassword = !showPassword"
              >
                <path
                  d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                ></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
              </svg>
            </div>

            <!-- Botón de inicio de sesión -->
            <div class="button-container">
              <v-btn
                @click="IniciarSesion()"
                :loading="loadingSesion"
                :disabled="loadingSesion || !cedula || !contrasena"
                class="login-button"
                size="large"
                block
                rounded
              >
                <span v-if="!loadingSesion">Iniciar Sesión</span>
                <template v-slot:loader>
                  <span class="d-flex align-center">
                    <v-icon class="mr-2" size="20">mdi-loading</v-icon>
                    Iniciando...
                  </span>
                </template>
              </v-btn>
            </div>
          </v-form>

          <!-- Footer del formulario -->
          <div class="form-footer">
            <div class="security-info">
              <v-icon size="16" color="#3b82f6" class="mr-2"
                >mdi-shield-check</v-icon
              >
              <span class="security-text">Acceso seguro y protegido</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Snackbar para notificaciones -->
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      location="top"
      class="modern-snackbar"
      :color="snackbarColor"
    >
      <div class="snackbar-content">
        <v-icon class="mr-3" :color="snackbarIconColor">{{
          snackbarIcon
        }}</v-icon>
        <span class="snackbar-text">{{ text }}</span>
      </div>
      <template v-slot:actions>
        <v-btn
          :color="snackbarIconColor"
          variant="text"
          @click="snackbar = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
import env from "./env";
export default {
  data: () => ({
    cedula: "",
    contrasena: "",
    showPassword: false,
    snackbar: false,
    y: "top",
    x: null,
    mode: "",
    timeout: 4000,
    text: "",
    loadingSesion: false,

    // Reglas de validación
    rules: {
      required: (value) => !!value || "Este campo es requerido",
    },
    snackbarColor: "error",
    snackbarIcon: "mdi-alert-circle",
    snackbarIconColor: "white",
  }),
  methods: {
    /**
     * Metodo para iniciar sesion
     */
    IniciarSesion() {
      this.loadingSesion = true;
      axios
        .get(
          `${env.endpoint}user/iniciar?cedula=${this.cedula}&pass=${this.contrasena}`
        )
        .then((res) => {
          if (res.data.mensaje === "inicio correcto") {
            localStorage.setItem("id", res.data.user.idUsuario);
            localStorage.setItem("nombre", res.data.user.nombre);
            localStorage.setItem("cedula", res.data.user.cedula);
            localStorage.setItem("rol", res.data.user.idRol);
            localStorage.setItem("nombreRol", res.data.user.nombreRol);
            localStorage.setItem("idArea", res.data.user.idArea);
            localStorage.setItem("area", res.data.user.area); 
            localStorage.setItem("firma", res.data.user.firma);

            if (res.data.user.nombreRol === "ADMINISTRADOR") {
              localStorage.setItem("homepage", "/Admin");
              this.$router.push("/Admin");
            } else if (res.data.user.nombreRol === "COMPRAS") {
              localStorage.setItem("homepage", "/Compras");
              this.$router.push("/Compras");
            } else if (res.data.user.nombreRol === "DIRECTOR DE AREA") {
              localStorage.setItem("homepage", "/DirectorArea");
              this.$router.push("/DirectorArea");
            } else if (res.data.user.nombreRol === "CONTROL INTERNO") {
              localStorage.setItem("homepage", "/ControlInterno");
              this.$router.push("/ControlInterno");
            } else if (res.data.user.nombreRol === "GERENTE") {
              localStorage.setItem("homepage", "/Gerente");
              this.$router.push("/Gerente");
            } else if (res.data.user.nombreRol === "REVISION") {
              localStorage.setItem("homepage", "/Revision");
              this.$router.push("/Revision");
            }
          } else {
            // Configurar snackbar según el tipo de error
            this.snackbarColor = "error";
            this.snackbarIcon = "mdi-alert-circle";
            this.snackbarIconColor = "white";

            if (res.data.mensaje === "faltan parametros") {
              this.text = "Por favor ingresar todos los datos";
            } else if (res.data.mensaje === "usuario no registrado") {
              this.text = "El usuario no está registrado en la plataforma";
            } else if (res.data.mensaje === "usuario inactivo") {
              this.text = "El usuario se encuentra inactivo en el sistema";
            } else {
              this.text = "Contraseña incorrecta";
            }
            this.snackbar = true;
          }
          this.loadingSesion = false;
        })
        .catch((e) => {
          console.log(e);
          this.snackbarColor = "error";
          this.snackbarIcon = "mdi-server-network-off";
          this.snackbarIconColor = "white";
          this.text =
            "Ha ocurrido un problema con el servidor, vuelva a intentar, si el problema persiste comuníquese con el área de sistemas.";
          this.snackbar = true;
          this.loadingSesion = false;
        });
    },
  },
};
</script>
<style scoped>
/* Contenedor principal */
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #ffffff 0%, #dbeafe 50%, #bfdbfe 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

/* Card principal */
.login-card {
  display: flex;
  width: 100%;
  max-width: 900px;
  min-height: 500px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* Sección de bienvenida */
.welcome-section {
  flex: 0 0 40%;
  position: relative;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.welcome-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.8;
}

.shape-1 {
  width: 200px;
  height: 200px;
  background: #60a5fa;
  top: -50px;
  left: -50px;
  border-radius: 60% 40% 30% 70%;
}

.shape-2 {
  width: 150px;
  height: 150px;
  background: #3b82f6;
  top: 20%;
  right: -30px;
  border-radius: 40% 60% 70% 30%;
}

.shape-3 {
  width: 180px;
  height: 180px;
  background: #2563eb;
  bottom: 10%;
  left: -40px;
  border-radius: 50% 30% 70% 40%;
}

.shape-4 {
  width: 120px;
  height: 120px;
  background: #1d4ed8;
  bottom: -20px;
  right: 20%;
  border-radius: 30% 70% 40% 60%;
}

.welcome-content {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 40px;
}

.welcome-title {
  color: white;
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
}

/* Sección del formulario */
.form-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: #f8fafc;
  background-image: radial-gradient(
    circle at 1px 1px,
    rgba(59, 130, 246, 0.1) 1px,
    transparent 0
  );
  background-size: 20px 20px;
}

.form-content {
  width: 100%;
  max-width: 420px;
}

/* Header del formulario */
.form-header {
  text-align: center;
  margin-bottom: 30px;
}

.form-icon {
  margin-bottom: 16px;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.form-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
  line-height: 1.2;
}

.form-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 20px 0;
  line-height: 1.4;
  font-weight: 500;
}

.form-divider {
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #3b82f6, #1d4ed8);
  border-radius: 2px;
  margin: 0 auto;
}

/* Formulario */
.login-form {
  width: 100%;
}

/* Contenedores de campos */
.field-container {
  margin-bottom: 24px;
  position: relative;
}

/* Contenedor especial para el campo de contraseña */
.password-field-container {
  position: relative;
  display: flex;
  align-items: center;
}

.field-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(59, 130, 246, 0.05),
    rgba(29, 78, 216, 0.05)
  );
  border-radius: 12px;
  z-index: -1;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.field-container:focus-within::before {
  opacity: 1;
}

/* Campos de entrada */
.custom-field {
  margin-bottom: 0;
}

.custom-field :deep(.v-field) {
  min-height: 52px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.custom-field :deep(.v-field__input) {
  font-size: 15px;
  padding: 14px 16px;
  font-weight: 500;
}

.custom-field :deep(.v-label) {
  font-size: 14px;
  font-weight: 600;
  color: #4b5563;
}

.custom-field :deep(.v-field__outline) {
  --v-field-border-opacity: 0.2;
  border-color: #e5e7eb;
  border-width: 2px;
}

.custom-field :deep(.v-field--focused .v-field__outline) {
  --v-field-border-opacity: 1;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.custom-field :deep(.v-field__outline__start) {
  border-radius: 12px 0 0 12px;
}

.custom-field :deep(.v-field__outline__end) {
  border-radius: 0 12px 12px 0;
}

.custom-field :deep(.v-field__outline__notch) {
  border-radius: 12px;
}

.custom-field :deep(.v-field--focused .v-label) {
  color: #3b82f6;
}

.custom-field :deep(.v-field__prepend-inner) {
  color: #6b7280;
}

.custom-field :deep(.v-field--focused .v-field__prepend-inner) {
  color: #3b82f6;
}

.custom-field :deep(.v-field__append-inner) {
  color: #6b7280 !important;
  cursor: pointer !important;
  transition: color 0.2s ease;
  font-size: 20px !important;
  opacity: 1 !important;
  visibility: visible !important;
}

.custom-field :deep(.v-field__append-inner:hover) {
  color: #3b82f6 !important;
}

.custom-field :deep(.v-field__append-inner .v-icon) {
  color: #6b7280 !important;
  font-size: 20px !important;
}

.custom-field :deep(.v-field__append-inner .v-icon:hover) {
  color: #3b82f6 !important;
}

/* Icono de toggle de contraseña */
.password-toggle-icon {
  position: absolute !important;
  right: 12px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  z-index: 10 !important;
  cursor: pointer !important;
  stroke: #6b7280 !important;
  transition: stroke 0.2s ease !important;
  width: 20px !important;
  height: 20px !important;
}

.password-toggle-icon:hover {
  stroke: #3b82f6 !important;
}

.password-toggle-icon.is-disabled {
  opacity: 0.45 !important;
  cursor: default !important;
  pointer-events: none !important;
}

/* Contenedor del botón */
.button-container {
  margin-bottom: 20px;
}

/* Botón de login */
.login-button {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8) !important;
  color: white !important;
  font-weight: 700;
  font-size: 16px;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
  min-height: 52px;
  padding: 14px 24px;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
}

.login-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s;
}

.login-button:hover::before {
  left: 100%;
}

.login-button:hover {
  background: linear-gradient(135deg, #2563eb, #1e40af) !important;
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.5);
  transform: translateY(-2px);
}

.login-button:disabled {
  background: #9ca3af !important;
  color: #d1d5db !important;
  transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Footer del formulario */
.form-footer {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.security-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.security-text {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}

/* Snackbar moderno */
.modern-snackbar {
  border-radius: 8px !important;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}

.snackbar-content {
  display: flex;
  align-items: center;
}

.snackbar-text {
  font-weight: 500;
  font-size: 14px;
}

/* Responsive design */
@media screen and (max-width: 768px) {
  .login-card {
    flex-direction: column;
    max-width: 100%;
    min-height: auto;
  }

  .welcome-section {
    flex: none;
    min-height: 200px;
    padding: 20px;
  }

  .welcome-title {
    font-size: 2rem;
  }

  .form-section {
    padding: 30px 20px;
  }

  .form-title {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 480px) {
  .login-container {
    padding: 10px;
  }

  .welcome-section {
    min-height: 150px;
    padding: 15px;
  }

  .welcome-title {
    font-size: 1.5rem;
  }

  .form-section {
    padding: 20px 15px;
  }

  .form-title {
    font-size: 1.3rem;
  }

  .login-button {
    font-size: 15px;
    min-height: 44px;
  }

  .custom-field :deep(.v-field) {
    min-height: 44px;
  }
}

/* Animaciones suaves */
.login-card {
  animation: slideUp 0.4s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Efectos de focus mejorados */
.custom-field :deep(.v-field--focused) {
  transform: scale(1.01);
  transition: transform 0.2s ease;
}

/* Mejoras de accesibilidad */
@media (prefers-reduced-motion: reduce) {
  .login-card {
    animation: none;
  }

  .custom-field :deep(.v-field--focused) {
    transform: none;
  }
}

/* Estados de validación */
.custom-field :deep(.v-field--error .v-field__outline) {
  border-color: #ef4444;
}

.custom-field :deep(.v-field--error .v-label) {
  color: #ef4444;
}
</style>
